






















import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {WarehouseStore} from "@/modules/warehouses/store";
import {PickingListStore} from "@/modules/pickinglists";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import PLPrintHeader from "./components/PickingListPrintHeader/index.vue";
import {PickingListType} from "@/enums/type/pickinglisttype";
import PLPrintContent from "./components/PickingListPrintContent/index.vue";
import PLPrintFooter
    from "@/modules/pickinglists/shared/component/PickingListPrint/components/PickingListPrintFooter/index.vue";

@Component({
    name: "PickingListPrint",
    components: {PLPrintFooter, PLPrintContent, PLPrintHeader}
})
export default class extends mixins(CommonMixin) {
    @Prop({ required: true, type: Number }) readonly id!: number;

    get warehouses() {
        return WarehouseStore.ids.map((id: number) => WarehouseStore.data[id]);
    }

    get pickingList() {
        return PickingListStore.data[this.id];
    }

    get title() {
        if (this.pickingList.type === PickingListType.Delivery)
            return 'Bảng kê chi tiết giao hàng';
        return 'Bảng kê chi tiết trung chuyển';
    }
}
